module.exports = __webpack_public_path__ + "static/media/tired.a2ea2cd2.svg";